var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Teacher',{attrs:{"teachers":_vm.getTeachers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }